import { render } from "./WorkspaceContainer.vue?vue&type=template&id=48d3f6f8&scoped=true&ts=true"
import script from "./WorkspaceContainer.vue?vue&type=script&lang=ts"
export * from "./WorkspaceContainer.vue?vue&type=script&lang=ts"

import "./WorkspaceContainer.vue?vue&type=style&index=0&id=48d3f6f8&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d3f6f8"]])

export default __exports__